import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const hasRequiredRoles = (
  route: ActivatedRouteSnapshot,
  authData: AuthGuardData,
): boolean => {
  const requiredRoles = route.data['roles'] as string[] | undefined;

  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  const grantedRoles = [
    ...authData.grantedRoles.realmRoles,
    ...Object.values(authData.grantedRoles.resourceRoles).flat(),
  ];

  return requiredRoles.some((requiredRole) =>
    grantedRoles.includes(requiredRole),
  );
};

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  if (!authData.authenticated) {
    await authData.keycloak.login({
      redirectUri: `${window.location.origin}${state.url}`,
    });

    return false;
  }

  return hasRequiredRoles(route, authData);
};

export const authGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
